module.exports = __webpack_public_path__ + "static/media/Greenlight.17d83252.webp";